import { Spinner } from '@orbita-ui/core';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '../auth/keycloak';
import { RealmRoles } from '../constants';
import { LoginPageContainer } from '../features/login/login.styles';
import useAuthService from '../hooks/useAuthService';
import useGetIssuerInformation from '../hooks/useGetIssuerInformation';
import { IIssuer } from '../interfaces/issuers';
import config from 'config';
import { useAppContext } from '../context/appContext';

const getIssuerFromPath = () =>{
  return  window.location.pathname.split('/')?.[1]?.toUpperCase();
}

const DEFAULT_ISSUER: string = config.api.issuer?.toLowerCase();

const Login = () => {
  const { keycloak, initialized } = useKeycloak();
  const { userHasRole } = useAuthService();
  const navigate = useNavigate();
  const {
    settings: { setIssuer },
  } = useAppContext();

  const routeIssuer = getIssuerFromPath();
  const [issuerName, setIssuerName] = useState<string>(['CONTACT_CENTER', 'RISK_MANAGEMENT', 'DIGITAL_ISSUING', 'DI_DISPUTE'].includes(routeIssuer) ? DEFAULT_ISSUER : routeIssuer || DEFAULT_ISSUER);
  const { executeGet } = useGetIssuerInformation({ manual: true, issuerName: issuerName });

  function getMainPageByRole(): string {
    if (userHasRole([RealmRoles.CardHolderAllRead, RealmRoles.CardHolderAllWrite])) {
      return `/${issuerName}/card-holders`;
    }

    if (userHasRole([RealmRoles.CurrencyExchangeAllRead, RealmRoles.CardHolderAllWrite])) {
      return `/${issuerName}/currency-exchange`;
    }

    if (userHasRole([RealmRoles.BalanceSettlementRead])) {
      return `/${issuerName}/settlement`;
    }

    if (userHasRole([RealmRoles.ExporterAllRead])) {
      return `/${issuerName}/exporter`;
    }
  }

  const useGetIssuerInformationData = async () => {
    try {
      const response = await executeGet();
      // @ts-ignore
      if(response.status === 200) {
        setIssuer({
          // @ts-ignore
          ...response?.data as IIssuer,
          // @ts-ignore
          name: response?.data?.name?.toLowerCase()
        });

        let mainPage = getMainPageByRole();
        if (mainPage === undefined) {
          mainPage = `/${issuerName}/welcome`;
        }

        navigate(mainPage);

      } else {
        //default - use issuer config
        setIssuer({ name: issuerName } as IIssuer);
      }
    } catch (e) {
      console.log(`Ocurrió un error: ${e}`);
    }
  }

  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated) {
        useGetIssuerInformationData();
      }

      if (!keycloak.authenticated) {
        keycloak.login();
      }
    }
  }, [initialized]);

  return (
    <LoginPageContainer>
      <Spinner />
    </LoginPageContainer>
  );
};

export default Login;
